
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


const RouteScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Set page title based on route
    const titles = {
      '/': 'Groupe Délices Benkirane',
      '/index-two': 'Groupe Délices Benkirane',
      '/index-three': 'Groupe Délices Benkirane',
      '/shop': 'Groupe Délices Benkirane - Boutique',
      '/product-details': 'Groupe Délices Benkirane - Détails du Produit',
      '/product-details-two': 'Groupe Délices Benkirane - Détails du Produit',
      '/cart': 'Groupe Délices Benkirane - Panier',
      '/checkout': 'Groupe Délices Benkirane - Commande',
      '/become-seller': 'Groupe Délices Benkirane - Devenir Vendeur',
      '/wishlist': 'Groupe Délices Benkirane - Liste de Souhaits',
      '/account': 'Groupe Délices Benkirane - Mon Compte',
      '/blog': 'Groupe Délices Benkirane - Actualité & Blog',
      '/blog-details': 'Groupe Délices Benkirane - Détails de l\'Article',
      '/track-order': 'Groupe Délices Benkirane - Suivre ma commande',
      '/contact': 'Groupe Délices Benkirane - Contact',
      '/vendor': 'Groupe Délices Benkirane - Vendeurs',
      '/vendor-details': 'Groupe Délices Benkirane - Détails du Vendeur',
      '/vendor-two': 'Groupe Délices Benkirane - Vendeurs',
      '/vendor-two-details': 'Groupe Délices Benkirane - Détails du Vendeur',
    };
    
    document.title = titles[pathname] || 'Groupe Délices Benkirane';
  }, [pathname]);

  return null;
};

export default RouteScrollToTop;
